import { Chip } from '@mui/material';
import { ExceptionSeverity } from '../../../mocks/data/procurementOverviewData';

const SEVERITY_COLOR: Record<ExceptionSeverity, 'success' | 'warning' | 'error'> = {
  Info: 'success',
  Warning: 'warning',
  Critical: 'error',
};

interface ExceptionSeverityChipProps {
  severity: ExceptionSeverity;
}

/** Shared severity chip for Procurement Overview exception tables (supplier, catalogue,
 * pricing and site readiness) so severity is displayed consistently across sections.
 * Demo Mode only, see src/mocks/data/procurementOverviewData.ts. */
const ExceptionSeverityChip: React.FC<ExceptionSeverityChipProps> = ({ severity }) => (
  <Chip label={severity}
    size="small"
    color={SEVERITY_COLOR[severity]} />
);

export default ExceptionSeverityChip;
